// src/data/exercises/L1_04.js

const accountOptions = [
  '仕入', '商品', '仮払消費税', '仮受消費税', '買掛金', '売上原価'];

export const L1_04 = {
  title: '簿記　3級（第217-4回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
        content: {

       parts: [
        { type: 'ruby', text: '島根', ruby: 'しまね' },
        { type: 'ruby', text: '株式会社', ruby: 'かぶしきがいしゃ' },
        { type: 'text', value: 'は，' },
        { type: 'ruby', text: '仕入先', ruby: 'しいれさき' },
        { type: 'text', value: 'から' },
        { type: 'ruby', text: '商品', ruby: 'しょうひん' },
        { type: 'text', value: '￥550,000（うち' },
        { type: 'ruby', text: '消費税額', ruby: 'しょうひぜいがく' },
        { type: 'text', value: '￥50,000）を' },
        { type: 'ruby', text: '購入', ruby: 'こうにゅう' },
        { type: 'text', value: 'し，' },
        { type: 'ruby', text: '代金', ruby: 'だいきん' },
        { type: 'text', value: 'は' },
        { type: 'ruby', text: '掛', ruby: 'か' },
        { type: 'text', value: 'けとした。ただし，' },
        { type: 'ruby', text: '当社', ruby: 'とうしゃ' },
        { type: 'text', value: 'は，' },
        { type: 'ruby', text: '商品売買取引', ruby: 'しょうひんばいばいとりひき' },
        { type: 'text', value: 'に' },
        { type: 'ruby', text: '関', ruby: 'かん' },
        { type: 'text', value: 'して，' },
        { type: 'ruby', text: '販売', ruby: 'はんばい' },
        { type: 'text', value: 'のつど' },
        { type: 'ruby', text: '売上原価', ruby: 'うりあげげんか' },
        { type: 'ruby', text: '勘定', ruby: 'かんじょう' },
        { type: 'text', value: 'に' },
        { type: 'ruby', text: '振', ruby: 'ふ' },
        { type: 'text', value: 'り' },
        { type: 'ruby', text: '替', ruby: 'か' },
        { type: 'text', value: 'える' },
        { type: 'ruby', text: '方法', ruby: 'ほうほう' },
        { type: 'text', value: '（' },
        { type: 'ruby', text: '売上原価対立法', ruby: 'うりあげげんかたいりつほう' },
        { type: 'text', value: '）で' },
        { type: 'ruby', text: '記帳', ruby: 'きちょう' },
        { type: 'text', value: 'している。なお，' },
        { type: 'ruby', text: '消費税', ruby: 'しょうひぜい' },
        { type: 'text', value: 'を' },
        { type: 'ruby', text: '税抜方式', ruby: 'ぜいぬきほうしき' },
        { type: 'text', value: 'で' },
        { type: 'ruby', text: '処理', ruby: 'しょり' },
        { type: 'text', value: 'する。' }
    ]

      },
      table: {
        options: accountOptions,
      },
      // Đáp án có 1 dòng Nợ và 2 dòng Có
      answer: [
        { debitAccount: '商品', debitAmount: 500000, creditAccount: '買掛金', creditAmount: 550000 },
        { debitAccount: '仮払消費税', debitAmount: 50000, creditAccount: null, creditAmount: null },
              ],
       // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '仕入先から商品￥550,000（うち消費税額￥50,000）を購入・・売上原価勘定に振り替える方法（売上原価対立法） \n' },
          { type: 'text', value: '①商品￥550,000（うち消費税額￥50,000）を購入なので、仕入を使いたいですが、 \n' },
          { type: 'text', value: '「売上原価勘定に振り替える方法（売上原価対立法）」とあるので、商品を使います。商品が増加（プラス）します。 \n' },
          { type: 'styled', value: '商品の増加（プラス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '商品の金額は￥550,000から消費税を引いた金額になります。 \n' },

          { type: 'text', value: '仕入先から商品￥550,000（うち消費税額￥50,000） \n' },
          { type: 'text', value: '②仕入れたときの消費税なので、仮払消費税を使います。仮払消費税が増加（プラス）します。 \n' },
          { type: 'styled', value: '仮払消費税の増加（プラス）は借方（左・Ｄｒ）に記入します。 \n\n', color: 'red', bold: true },

          { type: 'text', value: '仕入先から商品￥550,000・・・・代金は掛けとした。\n' },
          { type: 'text', value: '③仕入れたときの掛けなので、買掛金を使います。買掛金が増加（プラス）します。　\n' },
          { type: 'styled', value: '買掛金の増加は（プラス）は貸方（右・Ｃｒ）に記入します。　\n\n', color: 'red', bold: true },
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`仕入先から商品￥550,000（うち消費税額￥50,000）を購入・・売上原価勘定に振り替える方法（売上原価対立法）
①商品￥550,000（うち消費税額￥50,000）を購入なので、仕入を使いたいですが、
「売上原価勘定に振り替える方法（売上原価対立法）」とあるので、商品を使います。商品が増加（プラス）します。
②普通預金が増加（プラス）します。

仕入先から商品￥550,000（うち消費税額￥50,000）
②仕入れたときの消費税なので、仮払消費税を使います。仮払消費税が増加（プラス）します。

仕入先から商品￥550,000・・・・代金は掛けとした。
③仕入れたときの掛けなので、買掛金を使います。買掛金が増加（プラス）します。  `,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {

           parts: [
          { type: 'text', value: '仕入先から商品￥550,000（うち消費税額￥50,000）を購入・・売上原価勘定に振り替える方法（売上原価対立法） \n' },
          { type: 'text', value: '①商品￥550,000（うち消費税額￥50,000）を購入なので、仕入を使いたいですが、 \n' },
          { type: 'text', value: '「売上原価勘定に振り替える方法（売上原価対立法）」とあるので、商品を使います。商品が増加（プラス）します。 \n' },
          { type: 'styled', value: '商品の増加（プラス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '商品の金額は￥550,000から消費税を引いた金額になります。 \n' },

          { type: 'text', value: '仕入先から商品￥550,000（うち消費税額￥50,000） \n' },
          { type: 'text', value: '②仕入れたときの消費税なので、仮払消費税を使います。仮払消費税が増加（プラス）します。 \n' },
          { type: 'styled', value: '仮払消費税の増加（プラス）は借方（左・Ｄｒ）に記入します。 \n\n', color: 'red', bold: true },

          { type: 'text', value: '仕入先から商品￥550,000・・・・代金は掛けとした。\n' },
          { type: 'text', value: '③仕入れたときの掛けなので、買掛金を使います。買掛金が増加（プラス）します。　\n' },
          { type: 'styled', value: '買掛金の増加は（プラス）は貸方（右・Ｃｒ）に記入します。　\n\n', color: 'red', bold: true },
        ]

          }
        ],
        
      },
    },
  ],
};